// par paraugu ņemts un pārveidots https://github.com/tasti/react-linkify/blob/master/src/Linkify.jsx
// http://stackoverflow.com/questions/736513/how-do-i-parse-a-url-into-hostname-and-path-in-javascript

import React from 'react';

import Youtube from './Youtube.react.js';
import Thumb from './Thumb.react.js';
import GalleryStore from './../../stores/GalleryStore.js';
import ExternalImage from './ExternalImage.react.js';
import linkifyFactory from 'linkify-it';
import get from 'lodash/get';

const linkify = linkifyFactory();
const cacheServers = get(globals, 'cacheServers', null);

linkify
  .add('ftp:', null) // Disable `ftp:` ptotocol
  .add('mailto:', null) // Disable `mailto:` ptotocol
  .add('<a href="', {
  validate: function (text, pos, self) {
    var tail = text.slice(pos);
    return tail.indexOf("</a>")+4;
  },
  normalize: function (match) {
    var raw = match.raw.replace('\\"', '\\"');

    var url = raw.match(/(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig);
    var text = raw.match(/">(.*?)<\/a>/g);
    if(text != null) {
      text = text[0].substring(2, text[0].length-4);
      match.url = url[0];
    }

    
    match.text = text;
  }
});

// atgriež youtube id vai FALSE
// http://stackoverflow.com/a/9102270
function youtubeParser(url) {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
  const match = url.match(regExp);
  if (match && match[2].length == 11) {
    return match[2];
  }
  return false;
}

//
function gcloudParser(url) {
  const hostRegExpStr = `(${escapeRegExp('g.lindoamor.com')})`;
  const protocolRegExpStr = '^((?:https|http):\/\/)';
  const urlRegExpStr = '\/(?:o-(?:m|n|l)|h|l)\/([a-zA-Z0-9\-]+)(.jpg)?';
  const regExp = new RegExp(protocolRegExpStr + hostRegExpStr + urlRegExpStr);
  const match = url.match(regExp);
  if (match && match[3].length == 10) {
    return match;
  }
  return false;
}

function escapeRegExp(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}

// TODO: pārnest uz Imagify
function opImageParser(url) {
  const validHosts = [
    's.otrapuse.lv',
    's.lindoamor.com',
    'otrapuse.lv',
    'tavomeile.lt',
    'lindoamor.ee',
    'op.dev',
    'stage.otrapuse.lv',
    'antrapuse.lt',
    'phalcon.local:8000'
  ];

  //
  const currentHost = window.location.hostname + (window.location.port ? ':' + window.location.port : '');
  if (!validHosts.includes(currentHost)) {
    validHosts.push(currentHost);
  }

  let hostRegExpStr = '(';
  validHosts.forEach((item, index) => {
    if (index !== 0) {
      hostRegExpStr += '|';
    }

    hostRegExpStr += escapeRegExp(item);
  });
  hostRegExpStr += ')';
  const protocolRegExpStr = '^((?:https|http):\/\/)';
  const urlRegExpStr = '\/images\/get\/(?:o-(?:m|n|l)|h|l)\/([a-zA-Z0-9\-]+)(\/m|f)?';
  const regExp = new RegExp(protocolRegExpStr + hostRegExpStr + urlRegExpStr);
  const match = url.match(regExp);
  if (match && (match[3].length == 36 || match[3].length == 10)) {
    return match;
  }
  return false;
}

function externalImageParser(url) {
  return (url.match(/\.(jpeg|jpg|gif|png)(?:[\?]+[A-Za-z0-9_.-\/=&-]+)?$/) != null);
}

class Linkify extends React.Component {
  static defaultProps = {
    component: 'a',
    properties: {},
    thumbSize: 'o-n',
    imageLink: true,
    onlyImages: false,
    showUncensored: false
  };

  getMatches = string => linkify.match(string);

  parseString = (string) => {
    const elements = [];
    if (string === '') {
      return elements;
    }

    let matches = this.getMatches(string);

    if (!matches) {
      if (!string.includes('/images/get/') || string.length !== 52 || string.split('')[0] !== '/') {
        return string;
      }

      let basePath = '';

      if (cacheServers && cacheServers.length) {
        basePath = cacheServers[0];
      } else {
        basePath = get(globals, 'currentDomainName', 'otrapuse.lv');
      }

      if (basePath.charAt(basePath.length-1) === '/') {
        basePath = basePath.slice(0, -1);
      }

      const protocolRegExpStr = '^((?:https|http):\/\/)';
      const regExp = new RegExp(protocolRegExpStr);
      if (!basePath.match(regExp)) {
        if (basePath.includes('local')) {
          basePath = 'http://' + basePath;
        } else {
          basePath = 'https://' + basePath;
        }
      }

      matches = this.getMatches(basePath + string);

      if (!matches) {
        return string;
      }
    }

    let key = 0;
    let lastIndex = 0;
    let i;
    let externalImgCount = 0;
    for (i in matches) {
      const match = matches[i];
      // Push the preceding text if there is any
      if (match.index > lastIndex) {
        elements.push(React.createElement(
          'span',
          { key: key++ },
          string.substring(lastIndex, match.index),
        ));
      }

      const youtubeId = youtubeParser(match.url);
      const opImageMatch = opImageParser(match.url);
      const gcloudImageMatch = gcloudParser(match.url);
      const externalImageMatch = externalImageParser(match.url);

      // ievieto youtube bloku
      if (youtubeId && !this.props.onlyImages) {
        elements.push(<Youtube key={key++} id={youtubeId} />);
      }
      // op bildes
      else if (opImageMatch) {
        let baseURL = opImageMatch[1] + opImageMatch[2];
        let id = opImageMatch[3];
        let gcloud = false;
        // gcloud
        if (id.length === 10) {
          baseURL = 'https://g.lindoamor.com';
          id = `${id}.jpg`;
          gcloud = true;
        }
        var fileKey = `${this.props.messageId}_${key}`;
        if (!this.props.onlyImages) {
          GalleryStore.addLocalImage(id, fileKey, gcloud);
        }
        var _this = this;
        elements.push(<Thumb
          thumbSize={this.props.thumbSize}
          openGallery={this.props.openGallery}
          link={this.props.imageLink}
          key={key++}
          id={id}
          baseURL={baseURL}
          gcloud={gcloud}
        />);
      }
      // gcloud bildes
      else if (gcloudImageMatch) {
        const baseURL = gcloudImageMatch[1] + gcloudImageMatch[2];
        const id = gcloudImageMatch[3] + (gcloudImageMatch[4] || '');
        var fileKey = `${this.props.messageId}_${key}`;
        const uncensored = !this.props.showUncensored && gcloudImageMatch.input.includes('uncensored=true');
        if (!this.props.onlyImages) {
          GalleryStore.addLocalImage(id, fileKey, true, uncensored);
        }
        var _this = this;
        elements.push(<Thumb
          thumbSize={this.props.thumbSize}
          openGallery={this.props.openGallery}
          link={this.props.imageLink}
          key={key++}
          id={id}
          baseURL={baseURL}
          uncensored={uncensored}
          gcloud
        />);
      }
      // ārējās bildes
      else if (externalImageMatch) {
        var fileKey = `${this.props.messageId}_${key}`;
        if (!this.props.onlyImages) {
          GalleryStore.addLocalImage(match.url, fileKey);
        }
        var _this = this;
        if (externalImgCount == 0 || this.props.thumbSize != 't') {
          elements.push(<ExternalImage
            thumbSize={this.props.thumbSize}
            openGallery={this.props.openGallery}
            key={key++}
            link={match.url}
          />);
          externalImgCount++;
        }
      }
      // pārējie linki
      else {
        let component = this.props.component;
        const props = {
          key: key++,
          href: match.url,
          className: 'external-link',
        };
        if (this.props.onlyImages) {
          component = 'span';
          props.href = null;
          props.className = null;
        }

        elements.push(React.createElement(
          component,
          props,
          match.text,
        ));
      }

      lastIndex = match.lastIndex;
    }

    if (lastIndex !== string) {
      elements.push(React.createElement(
        'span',
        { key: key++ },
        string.substring(lastIndex),
      ));
    }

    return (elements.length === 1) ? elements[0] : elements;
  };

  parse = (children) => {
    const self = this;
    let parsed = children;

    // return (<Youtube id="YfFhxA2JFOA"></Youtube>);

    if (typeof children === 'string') {
      parsed = this.parseString(children);
    } else if (React.isValidElement(children) && (children.type !== 'a') && (children.type !== 'button')) {
      parsed = React.cloneElement(
        children,
        {},
        this.parse(children.props.children),
      );
    } else if (children instanceof Array) {
      parsed = children.map(child => self.parse(child));
    }

    return parsed;
  };

  render() {
    const parsedChildren = this.parse(this.props.children);

    return (
      <div className="Linkify">{parsedChildren}</div>
    );
  }
}

module.exports = Linkify;
